import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seek-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})
export class TrainingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
